import LayoutComposer from './LayoutComposer.js';
import LayoutSingleColumn from './LayoutSingleColumn/LayoutSingleColumn';
import LayoutSideNavigation from './LayoutSideNavigation/LayoutSideNavigation';

export { LayoutSingleColumn, LayoutSideNavigation };
export default LayoutComposer;
